<template>
    <div v-if="!separateSources">
        <div v-if="estorageMisconfigured" class="estorage-config-alert">
            O e-storage não está configurado corretamente.
        </div>
        <FileCarousel v-if="localFiles.length" :files="localFiles" />
        <span v-else-if="!estorageMisconfigured" class="empty-files">Nenhum arquivo.</span>
    </div>

    <div v-else class="document-sources">
        <div class="document-source">
            <span class="document-source-title">Arquivos WebGis</span>
            <FileCarousel v-if="geoFiles.length" :files="geoFiles" />
            <span v-else class="empty-files-inline">Nenhum arquivo enviado pelo WebGis.</span>
        </div>

        <div class="document-source">
            <span class="document-source-title">Arquivos e-cidade</span>
            <div v-if="estorageMisconfigured" class="estorage-config-alert">
                O e-storage não está configurado corretamente.
            </div>
            <FileCarousel v-else-if="ecidadeFiles.length" :files="ecidadeFiles" />
            <span v-else class="empty-files-inline">Nenhum arquivo proveniente do e-cidade.</span>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import FileCarousel from '../../../FileCarousel.vue'

const props = defineProps({
    files: {
        type: Array,
        default: () => [],
    },
    separateSources: {
        type: Boolean,
        default: false,
    },
    estorageMisconfigured: {
        type: Boolean,
        default: false,
    },
})

const geoFiles = computed(() => props.files.filter(file => file.source === 'geo'))
const ecidadeFiles = computed(() => props.files.filter(file => file.source !== 'geo'))

// Sem separação, arquivos do e-storage não renderizam quando ele está indisponível.
const localFiles = computed(() => props.estorageMisconfigured
    ? props.files.filter(file => !file.estorageId)
    : props.files)
</script>

<style scoped>
.document-sources {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 12px;
}

.document-source {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.document-source-title {
    font-weight: bold;
}

.estorage-config-alert {
    margin-top: 12px;
    padding: 12px;
    background: #fff2f0;
    border: 1px solid #ffccc7;
    border-radius: 4px;
    color: #a8071a;
    font-size: 13px;
}

.empty-files {
    color: #888;
    font-size: 12px;
    margin-top: 12px;
    display: block;
}

.empty-files-inline {
    color: #888;
    font-size: 12px;
}
</style>
